<template>
  <header class="header-mb header-right">
    <div class="header-ipad">
      <div class="icon-logo-desk opacity-0">
        <div class="logo"><a class="logo-body"><img class="img-header lazyLoad isLoaded"
              src="/static/img/landing/logo.png"></a></div>
        <!---->
      </div>
      <section class="header-index">
        <div class="icon-logo"><a class="icon"><img
              data-src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjRweCIgaGVpZ2h0PSIyNHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InNjLWZ6blplWSBiWVl1WWciPjxwYXRoIGRhdGEtdi0zMTRmNTNjNj0iIiBmaWxsPSIjRkZGRkZGIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zLjg0MSA0LjY2M0E1MS4zMTIgNTEuMzEyIDAgMDExMi4wMDEgNGMyLjc3MiAwIDUuNTAyLjIzNSA4LjE0OS42NjNhMSAxIDAgMDEtLjMyIDEuOTc0QTQ5LjA5IDQ5LjA5IDAgMDAxMiA2YTQ5LjMgNDkuMyAwIDAwLTcuODQuNjM3IDEgMSAwIDAxLS4zMTktMS45NzR6TTMuMDEzIDE4LjE5YTEgMSAwIDAxMS4xNDYtLjgyN0M2LjcxNyAxNy43NzUgOS4zMyAxOCAxMiAxOHM1LjI4My0uMjI1IDcuODQxLS42MzdhMSAxIDAgMDEuMzE4IDEuOTc0QTUxLjIyMiA1MS4yMjIgMCAwMTEyIDIwYy0yLjc4MyAwLTUuNTAzLS4yMzUtOC4xNTktLjY2M2ExIDEgMCAwMS0uODI4LTEuMTQ2ek0zLjA0IDEyYTEgMSAwIDAxMS0xaDE1LjkyYTEgMSAwIDExMCAySDQuMDRhMSAxIDAgMDEtMS0xeiI+PC9wYXRoPjwvc3ZnPg=="
              alt="" class="lazyLoad"></a>
          <div class="logo"><a class="logo-body"><img data-src="https://cdn.apixbet.com/app/images/brand/logo.png"
                class="lazyLoad"></a></div>
          <!---->
        </div>
        <div class="laRPJI iKTksx2"><input id="inputHeader" type="text" autocomplete="off"
            placeholder="ลอง &quot;โรม่า&quot;" name="search" class="cXIeXK">
          <div id="btnSearch" class="jXWXLS"><img alt="" class="lazyLoad isLoaded"
              src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjRweCIgaGVpZ2h0PSIyNHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgZGlyZWN0aW9uPSJyaWdodCIgY2xhc3M9InNjLWZia2hJdiBpR2xLQVEiPjxwYXRoIGQ9Ik0xMS4xMTkgMTcuOTc3YzMuOTMxIDAgNy4xMTktMy4xMyA3LjExOS02Ljk4OSAwLTMuODYtMy4xODgtNi45ODgtNy4xMi02Ljk4OEM3LjE4OSA0IDQgNy4xMjkgNCAxMC45ODhjMCAzLjg2IDMuMTg3IDYuOTg5IDcuMTE5IDYuOTg5ek0xNS42ODggMTYuNzA2bDQuMjUgNC4yMzUiIHN0cm9rZT0iIzg2OTdBMiIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCI+PC9wYXRoPjwvc3ZnPg==">
          </div>
        </div>
        <div class="btn-profile">
          <div class="sc-TmcTc cJbABh"><a href="https://orcbet.app/register" class="reg-hover"><span
                class="text-1"><strong>สมัคร</strong></span></a> <a href="https://orcbet.app/login" class="eGHGZc"><button
                class="btnGreen">
                <div class="llPLzd2"><span class="text-1"><strong>เข้าสู่ระบบ</strong></span></div>
              </button></a></div>
          <!---->
          <!---->
        </div>
      </section>
    </div>
  </header>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { UserInfoMixins } from '@/mixins/UserInfo.js'

export default {
  name: 'Header',
  data() {
    return {
      isShowNav: true,
      nowPage: this.$route.name,
    }
  },
  watch: {
    $route() {
      this.isShowNav = true
      this.nowPage = this.$route.name
      if (
        this.$route.name == 'Login' ||
        this.$route.name == 'Signup' ||
        this.$route.name == 'Profile' ||
        this.$route.name == 'Join'
      ) {
        return (this.isShowNav = false)
      }
    },
  },
  mixins: [UserInfoMixins],
  methods: {
    ...mapActions(['userSignOut', 'appTitle']),
    getPageActive(page) {
      if (this.nowPage == page) {
        return 'menu-item menu-item-type-custom menu-item-object-custom current-menu-item current_page_item menu-item-home menu-item-9'
      }
    },
    async SignOut() {
      await this.userSignOut()
    },
  },
  computed: {
    ...mapGetters(['getLineId']),
  },
}
</script>
<style scoped>
/* @import "./../assets/css/home.css"; */
</style>



// WEBPACK FOOTER //
// src/components/layout/Header.vue